import { c as _c } from "react/compiler-runtime";
import { useProductBuilderContext } from "./ProductBuilderContext";
export default function Title() {
  const $ = _c(2);
  const {
    parentProductTitle,
    productWrapper,
    product
  } = useProductBuilderContext();
  const title = parentProductTitle || productWrapper.titleOverride || product?.title;
  if (!title) {
    return null;
  }
  let t0;
  if ($[0] !== title) {
    t0 = <h1 className="text-2xl mb-3 font-black text-card-foreground">{title}</h1>;
    $[0] = title;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}